type LogFn = (...args: unknown[]) => void;

interface Logger {
  info: LogFn;
  warn: LogFn;
  error: LogFn;
  debug: LogFn;
}

const noop: LogFn = () => {};

const enabled = process.env.NEXT_PUBLIC_LOG_LEVEL === 'debug';

/* eslint-disable no-console */
export const logger: Logger = enabled
  ? {
      info: console.log.bind(console),
      warn: console.warn.bind(console),
      error: console.error.bind(console),
      debug: console.debug.bind(console),
    }
  : { info: noop, warn: noop, error: console.error.bind(console), debug: noop };
/* eslint-enable no-console */
